package org.example.project.settings

import androidx.compose.runtime.Composable
import org.example.project.dashboard.DashboardTheme
import org.example.project.service.PasswordPolicy
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.Style
import org.jetbrains.compose.web.css.StyleSheet
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

object PasswordRequirementHintStyles : StyleSheet() {
    val row by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(8.px)
        color(DashboardTheme.TEXT_MUTED)
        fontSize(12.px)
    }

    val requirementMet by style {
        color(DashboardTheme.TEXT_LIGHT)
    }
}

@Composable
fun PasswordRequirementHint(
    password: String,
    text: String = PasswordPolicy.REQUIREMENT_TEXT
) {
    Style(PasswordRequirementHintStyles)
    val valid = PasswordPolicy.isValid(password)
    Span({
        classes(PasswordRequirementHintStyles.row)
        if (valid) classes(PasswordRequirementHintStyles.requirementMet)
    }) {
        Span { Text(if (valid) "✓" else "○") }
        Text(text)
    }
}
